// libs
import { keyframes } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const slideUpAnimation = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0%);
    }
`;

export const Container = styled.div<{ isBottomSheet: boolean; showBorder: boolean }>`
  background-color: ${({ theme }) => `${theme.colors.surface}`};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    position: sticky;
    z-index: 5;
    width: calc(100% + 32px);
    margin-bottom: ${({ theme, isBottomSheet }) => (isBottomSheet ? 0 : theme.spacing.spacing40)};
    width: ${({ isBottomSheet }) => (!isBottomSheet ? `100vw` : '100%')};
    padding: ${({ theme, isBottomSheet }) => (!isBottomSheet ? theme.spacing.spacing80 : 0)};
    margin-left: -${({ theme, isBottomSheet }) => (!isBottomSheet ? theme.spacing.spacing80 : 0)};
    border-top: ${({ showBorder, theme }) =>
      showBorder ? `1px solid ${theme.colors.textOutline}}` : 'none'};
    bottom: 0;
    left: 0;
    animation: ${slideUpAnimation} 0.3s ease-in;
  }
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0;
    width: 100%;
    animation: none;
    margin-top: ${({ theme }) => theme.spacing.spacing160};
  }
`;
